import { apiClient } from '../../axios';
import {
  PostChannelVerificationReportParams,
  PostChannelVerificationReportResponse,
  PostChannelVerificationVerifyParams,
  PostChannelVerificationVerifyResponse,
} from './types';

export const postChannelVerificationVerifyApi = (data: PostChannelVerificationVerifyParams) =>
  apiClient.post<PostChannelVerificationVerifyResponse>('/v1/channel-verification/verify', data);

export const postChannelVerificationReportApi = (data: PostChannelVerificationReportParams) =>
  apiClient.post<PostChannelVerificationReportResponse>('/v1/channel-verification/report', data);
